import { defineComponent as _defineComponent } from 'vue'
import HeadlinedTitleList from '@/components/HeadlinedTitleList.vue';

import { useSimilarTitles } from '@/helpers/composables/useSimilarTitles';

import type { TitleFilter } from '@/@types/graphql-types';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetailSeason, TitleDetail } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';

interface SimilarTitlesProps {
	title: NonNullable<TitleDetail | TitleDetailSeason['show']>;
	isUpcoming?: boolean;
	filters?: TitleFilter;
	minTitles?: number;
	sponsoredAd?: SponsoredAdFragment | undefined;
	additionalContexts?: SnowplowContext[];
	impressionTrackingLabel?: string;
	impressionTrackingProperty?: string; // @todo problems with enum types - ImpressionTrackingEvents | '';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarTitles',
  props: {
    title: null,
    isUpcoming: { type: Boolean, default: false },
    filters: { default: () => ({}) },
    minTitles: { default: 1 },
    sponsoredAd: { default: undefined },
    additionalContexts: { default: () => [] },
    impressionTrackingLabel: { default: '' },
    impressionTrackingProperty: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: NonNullable<TitleDetail | TitleDetailSeason['show']>, isUpcoming: boolean, filters: TitleFilter, minTitles: number, sponsoredAd: SponsoredAdFragment | undefined, additionalContexts: SnowplowContext[], impressionTrackingLabel: string, impressionTrackingProperty: string };



const { similarTitles, isEmpty } = useSimilarTitles({
	titleId: () => props.title.id,
	isUpcoming: () => props.isUpcoming,
	filters: () => props.filters,
	minTitles: () => props.minTitles,
});

return { __sfc: true,props, similarTitles, isEmpty, HeadlinedTitleList }
}

})